import { trace } from '@opentelemetry/api';

const sendOpenTelemetryEvent = (message: string) => {
  const span = trace
    .getTracer('hpaip-upgrade-mfe')
    .startSpan('hpaip-upgrade-mfe', {
      attributes: {
        'workflow.name': 'monetization/hpaip-upgrade-mfe.error',
        error: true,
        'error.message': message
      }
    });
  span.end();
};

export default sendOpenTelemetryEvent;
